import { useEffect } from 'react';
import { Router } from 'react-router-dom';

import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@material-ui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import legacyTheme from './legacyTheme';
import theme from './theme';

import { createBrowserHistory } from 'history';
import validate from 'validate.js';
import { validators } from './common';
import './App.css';
import { AppRouter } from "./AppRouter";
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import Loading from './common/Loading';
import 'react-perfect-scrollbar/dist/css/styles.css'
import './index.css'
import store from './redux/store';

const browserHistory = createBrowserHistory();

validate.validators = {
  ...validate.validators,
  ...validators
};

export function App() {

  return (
    <Provider store={ store }>
      <LegacyThemeProvider theme={ legacyTheme }>
        <MuiThemeProvider theme={ theme }>
          <CssBaseline />
          <Router history={ browserHistory }>
            <AppRouter/>
          </Router>
       </MuiThemeProvider>
      </LegacyThemeProvider>
      <ReduxToastr timeOut={40000} />
      <Loading />
    </Provider>
  );
}
